export const ImagesConfig = {
	api: "https://images.bolaopenacova.com",
	public_key: "77uzmyqbri5x",
};
